// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"0744145f","357":"8616da07","362":"8b0f5618","453":"3999ceec","553":"fc6b5d2b","591":"ab1c7cce","620":"ed125f04","683":"306a1db3","903":"4ece33e1","910":"6fa27459"}[chunkId] + ".chunk.js";
};